import type { AgentStat, MapStat } from "../types";

export function AgentTable({ agents }: { agents: AgentStat[] }) {
  return (
    <div className="table-scroll">
      <table>
        <thead><tr><th>Agent</th><th>Matches</th><th>Win rate</th><th>K/D</th><th>ACS</th><th>Kills</th><th>Playtime</th></tr></thead>
        <tbody>{agents.map((agent) => (
          <tr key={agent.name}>
            <td><span className="agent-mark">{agent.name.slice(0, 1)}</span><strong>{agent.name}</strong></td>
            <td>{agent.matches}</td><td>{agent.winRate.toFixed(1)}%</td><td>{agent.kd.toFixed(2)}</td><td>{agent.acs}</td><td>{agent.kills}</td><td>{Math.round(agent.playtimeMinutes / 60)}h {agent.playtimeMinutes % 60}m</td>
          </tr>
        ))}</tbody>
      </table>
    </div>
  );
}

export function MapTable({ maps }: { maps: MapStat[] }) {
  return (
    <div className="table-scroll">
      <table>
        <thead><tr><th>Map</th><th>Matches</th><th>Wins</th><th>Losses</th><th>Win rate</th><th>K/D</th></tr></thead>
        <tbody>{maps.map((map) => (
          <tr key={map.name}><td><strong>{map.name}</strong></td><td>{map.matches}</td><td>{map.wins}</td><td>{map.losses}</td><td>{map.winRate.toFixed(1)}%</td><td>{map.kd.toFixed(2)}</td></tr>
        ))}</tbody>
      </table>
    </div>
  );
}
